import { Component, OnInit } from '@angular/core';
import {
  AnalyticsEvent,
  Banner,
  Benefits,
  CardCarousel,
  EarnsSummary,
  MicroMoments,
  Offers,
  Onboarding,
  QuickLinks,
  SkyClubSpendTracker,
  SkyClubTracker,
  Snapshot,
  Tracker,
  Upgrades
} from '@com-delta-idp/mnx-skymiles-overview-ui';
import {
  AnalyticsClick,
  RelatedLinks,
  Stipulation,
  Summary,
  SummaryAnalyticsEvent
} from '@com-delta-idp/mnx-skymiles-shared';
import { StateFacade } from '../../data-access/facades/state.facade';
import { TrackerFacade } from '../../data-access/facades/tracker.facade';
import { setAnalyticsClick } from '../../data-access/services/analytics/data-layer-click.utils';
import { DataLayerAnalyticsService } from '../../data-access/services/analytics/data-layer.service';

@Component({
  selector: 'idp-skymiles-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.sass']
})
export class OverviewComponent implements OnInit {
  emptyOnboarding: Onboarding = {} as Onboarding;
  emptyMicroMoments: MicroMoments = {} as MicroMoments;
  emptySummary: Summary = {} as Summary;
  emptyTracker: Tracker = {} as Tracker;
  emptyStatus: Summary = {} as Summary;
  emptyCards: CardCarousel = {} as CardCarousel;
  emptyEarnsSummary: EarnsSummary = {} as EarnsSummary;
  emptySkyClubTracker: SkyClubTracker = {} as SkyClubTracker;
  emptyAmexSkyClubTracker: SkyClubSpendTracker = {} as SkyClubSpendTracker;
  emptyQuickLinks: QuickLinks = {} as QuickLinks;
  emptyBenefits: Benefits = {} as Benefits;
  emptySnapshot: Snapshot = {} as Snapshot;
  emptyUpgrades: Upgrades = {} as Upgrades;
  emptyBanner: Banner = {} as Banner;
  emptyOffers: Offers = {} as Offers;
  emptyRelatedLinks: RelatedLinks = {} as RelatedLinks;
  emptyStipulation: Stipulation = {} as Stipulation;

  constructor(
    public overview: StateFacade,
    public tracker: TrackerFacade,
    private dataLayerAnalyticsService: DataLayerAnalyticsService
  ) {
    this.overview.init();
  }

  ngOnInit() {
    this.overview.initAnalytics();
  }

  close() {
    localStorage.setItem('welcomeTourModal', JSON.stringify(false));
  }

  redirect(url: string, type: string) {
    window.open(url, type === 'link' ? '_blank' : '_self');
  }

  setAnalyticsOnModalClick(data: string) {
    this.dataLayerAnalyticsService.setModalClickAnalytics(data);
  }

  onAnalyticsEvent(event: SummaryAnalyticsEvent): void {
    this.dataLayerAnalyticsService.setLinkClickAnalytics(
      event,
      this.dataLayerAnalyticsService.assets
    );
  }

  setAnalyticsOnCardClick(data: AnalyticsClick) {
    setAnalyticsClick(data, this.dataLayerAnalyticsService.assets);
  }

  bannerClickEvent(event: AnalyticsEvent) {
    const customEvent = new CustomEvent(event.eventName, {
      bubbles: true,
      detail: JSON.stringify({
        ...JSON.parse(event.eventData),
        assets: this.dataLayerAnalyticsService.assets
      })
    });
    document.dispatchEvent(customEvent);
  }
}
